import { useState, useEffect } from 'react';
import DatePicker from '../../components/DatePicker';
import { apiRequest } from '../../services/api';
import { downloadExcel, printTable } from '../../utils/exportUtils';
import EmptyState from '../../components/EmptyState';
import DataTable, { Rozet } from '../../components/DataTable';

// ─── Sabitler ───────────────────────────────────────────────
var FATURA_TURLERI  = ['Hepsi', 'TEMEL', 'TİCARİFATURA'];
var FATURA_TIPLERI  = ['Hepsi', 'e-Fatura', 'e-Arşiv'];
var YANIT_DURUMLARI = ['Hepsi', 'KABUL', 'RED', 'BEKLEMEDE', 'YANIT VERİLMEDİ'];
var ODEME_DURUMLARI = ['Hepsi', 'ÖDENDİ', 'BEKLEMEDE', 'VADELİ', 'GECİKMİŞ'];
var AYLAR           = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];


function padG(n){ return String(n).padStart(2,'0'); }
function ayniBasi(ay){ var d=new Date(); d.setMonth(ay); d.setDate(1); return '01.'+padG(ay+1)+'.'+d.getFullYear(); }
function ayniSonu(ay){ var d=new Date(new Date().getFullYear(),ay+1,0); return padG(d.getDate())+'.'+padG(ay+1)+'.'+d.getFullYear(); }
function ddToDate(s){ if(!s) return null; var p=s.split('.'); return new Date(+p[2],+p[1]-1,+p[0]); }

var YANIT_BADGE = {
  'KABUL':            'bg-emerald-100 text-emerald-700',
  'RED':              'bg-rose-100 text-rose-700',
  'BEKLEMEDE':        'bg-amber-100 text-amber-700',
  'YANIT VERİLMEDİ': 'bg-slate-100 text-slate-500',
};
var ODEME_BADGE = {
  'ÖDENDİ':    'bg-emerald-100 text-emerald-700',
  'VADELİ':    'bg-indigo-100 text-indigo-700',
  'BEKLEMEDE': 'bg-amber-100 text-amber-700',
  'GECİKMİŞ':  'bg-rose-100 text-rose-700',
};

// ─── Detay Modal ──────────────────────────────────────────────
function DetayModal({ f, onKapat, onKabul, onRed }) {
  var [redNeden, setRedNeden] = useState('');
  var [redAcik, setRedAcik] = useState(false);
  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[70] flex items-center justify-center p-4">
      <div className="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-lg overflow-hidden animate-fade-in">
        <div className="px-8 py-6 bg-slate-50 flex items-center justify-between border-b border-slate-100">
          <div>
            <h2 className="text-xl font-black text-slate-800 tracking-tight">Gelen Fatura Detayı</h2>
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1">{f.uuid}</p>
          </div>
          <button onClick={onKapat} className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50 transition-all font-black">×</button>
        </div>
        <div className="px-8 py-6 space-y-4 text-sm">
          {[
            ['Fatura No', f.no],
            ['Tür / Tip', f.tur+' · '+f.tip],
            ['Tarih / Saat', f.tarih+' '+f.saat],
            ['Gönderen', f.gonderen],
            ['TC / Vergi No', f.tcVergi],
            ['Açıklama', f.aciklama],
            ['Vade Tarihi', <span className="font-bold text-rose-500">{f.vade}</span>],
            ['KDV Tutarı', <span className="font-mono text-slate-500">{f.kdv.toFixed(2)} ₺</span>],
            ['Genel Toplam', <span className="text-xl font-black text-indigo-600">{f.tutar.toFixed(2)} ₺</span>],
          ].map((r,i) => (
            <div key={i} className="flex justify-between items-center border-b border-slate-50 pb-3">
              <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{r[0]}</span>
              <span className="font-bold text-slate-700 text-right">{r[1]}</span>
            </div>
          ))}
          <div className="flex justify-between items-center border-b border-slate-50 pb-3 pt-2">
            <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Yanıt Durumu</span>
            <span className={`text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest ${YANIT_BADGE[f.yanitDurum] || 'bg-slate-100 text-slate-500'}`}>{f.yanitDurum}</span>
          </div>
          <div className="flex justify-between items-center pt-2">
            <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Ödeme Durumu</span>
            <span className={`text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest ${ODEME_BADGE[f.odemeDurum] || 'bg-slate-100 text-slate-500'}`}>{f.odemeDurum}</span>
          </div>
        </div>
        
        {redAcik && (
          <div className="px-8 pb-4 animate-fade-in">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-2">Red Gerekçesi</label>
            <textarea value={redNeden} onChange={e=>setRedNeden(e.target.value)} rows={2}
              className="w-full bg-slate-50 border-2 border-transparent focus:border-rose-400 rounded-xl px-4 py-3 text-xs font-black text-slate-700 outline-none transition-all resize-none" placeholder="GIB'e iletilecek red gerekçeniz..."/>
            <div className="flex gap-2 mt-3">
              <button onClick={()=>{onRed(f,redNeden);onKapat();}} className="bg-gradient-to-r from-rose-500 to-red-600 hover:from-rose-600 hover:to-red-700 text-white font-black text-[10px] uppercase tracking-widest px-6 py-2 rounded-xl shadow-lg shadow-rose-500/30 transition-all active:scale-95">Reddet ve Gönder</button>
              <button onClick={()=>setRedAcik(false)} className="bg-slate-100 hover:bg-slate-200 text-slate-600 font-black text-[10px] uppercase tracking-widest px-6 py-2 rounded-xl transition-all">Vazgeç</button>
            </div>
          </div>
        )}
        
        <div className="px-8 pb-8 flex gap-2 flex-wrap sm:flex-nowrap">
          <button className="flex-1 bg-white border-2 border-slate-100 hover:border-slate-300 text-slate-600 font-black text-[10px] uppercase tracking-widest py-3 rounded-2xl transition-all shadow-sm">📄 PDF İndir</button>
          
          {(f.yanitDurum==='BEKLEMEDE'||f.yanitDurum==='YANIT VERİLMEDİ') && !redAcik && (
            <>
              <button onClick={()=>{onKabul(f);onKapat();}} className="flex-1 bg-gradient-to-r from-emerald-400 to-teal-500 hover:from-emerald-500 hover:to-teal-600 text-white font-black text-[10px] uppercase tracking-widest py-3 rounded-2xl shadow-lg shadow-emerald-500/30 transition-all active:scale-95">✅ Kabul</button>
              <button onClick={()=>setRedAcik(true)} className="flex-1 bg-gradient-to-r from-rose-400 to-red-500 hover:from-rose-500 hover:to-red-600 text-white font-black text-[10px] uppercase tracking-widest py-3 rounded-2xl shadow-lg shadow-rose-500/30 transition-all active:scale-95">❌ Reddet</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Ana Sayfa ────────────────────────────────────────────────
export default function GelenFaturalar() {
  var suankiAy = new Date().getMonth();
  var [ay, setAy]               = useState(AYLAR[suankiAy]);
  var [bas, setBas]             = useState(ayniBasi(suankiAy));
  var [bit, setBit]             = useState(ayniSonu(suankiAy));
  var [fatTur, setFatTur]       = useState('Hepsi');
  var [fatTip, setFatTip]       = useState('Hepsi');
  var [yanitD, setYanitD]       = useState('Hepsi');
  var [odemeD, setOdemeD]       = useState('Hepsi');
  var [gonderenAra, setGonderenAra] = useState('');
  var [noAra, setNoAra]         = useState('');
  var [vadGec, setVadGec]       = useState(false);
  var [snap, setSnap]           = useState({bas:ayniBasi(suankiAy),bit:ayniSonu(suankiAy),fatTur:'Hepsi',fatTip:'Hepsi',yanitD:'Hepsi',odemeD:'Hepsi',gonderen:'',no:'',vadGec:false});
  var [detay, setDetay]         = useState(null);
  var [data, setData]           = useState([]);
  var [yukleniyor, setYukleniyor] = useState(false);
  var [hata, setHata]           = useState(null);
  var [sortK, setSortK]         = useState('tarih');
  var [sortD2, setSortD2]       = useState('desc');

  function pad(n){ return String(n).padStart(2,'0'); }
  function isoToTarih(iso){ if(!iso) return ''; var d=new Date(iso); return pad(d.getDate())+'.'+pad(d.getMonth()+1)+'.'+d.getFullYear(); }
  function isoToSaat(iso){ if(!iso) return ''; var d=new Date(iso); return pad(d.getHours())+':'+pad(d.getMinutes()); }

  async function yukle(basTarih, bitTarih) {
    setYukleniyor(true); setHata(null);
    try {
      function toIso(s){ var p=s.split('.'); return p[2]+'-'+p[1]+'-'+p[0]; }
      var resp = await apiRequest(`efatura/gelen?baslangic=${toIso(basTarih)}&bitis=${toIso(bitTarih)}`);
      setData((resp||[]).map((f,i) => ({
        id: f.uuid || String(i),
        uuid: f.uuid || '',
        no: f.faturaNo || '',
        tip: f.faturaTipi || 'e-Fatura',
        tarih: isoToTarih(f.tarih),
        saat: isoToSaat(f.tarih),
        gonderen: f.gonderenAdi || '',
        tcVergi: f.gonderenVkn || '',
        tutar: f.tutar || 0,
        kdv: f.kdvTutari || 0,
        yanitDurum: f.durum || 'BEKLEMEDE',
        odemeDurum: '—',
        aciklama: '',
      })));
    } catch(e) {
      setHata(e.message);
    } finally {
      setYukleniyor(false);
    }
  }

  useEffect(() => { yukle(bas, bit); }, []);

  function ayDegis(v){ setAy(v); var i=AYLAR.indexOf(v); setBas(ayniBasi(i)); setBit(ayniSonu(i)); }
  function filtrele(){ setSnap({bas,bit,fatTur,fatTip,yanitD,odemeD,gonderen:gonderenAra,no:noAra,vadGec}); yukle(bas,bit); }
  function temizle(){
    var b=ayniBasi(suankiAy), e=ayniSonu(suankiAy);
    setAy(AYLAR[suankiAy]); setBas(b); setBit(e);
    setFatTur('Hepsi'); setFatTip('Hepsi'); setYanitD('Hepsi'); setOdemeD('Hepsi');
    setGonderenAra(''); setNoAra(''); setVadGec(false);
    setSnap({bas:b,bit:e,fatTur:'Hepsi',fatTip:'Hepsi',yanitD:'Hepsi',odemeD:'Hepsi',gonderen:'',no:'',vadGec:false});
    yukle(b,e);
  }

  function kabul(f){ setData(p => p.map(x => x.id===f.id?{...x,yanitDurum:'KABUL'}:x)); }
  function red(f, neden){ setData(p => p.map(x => x.id===f.id?{...x,yanitDurum:'RED',redNeden:neden}:x)); }

  var bugun = new Date(); bugun.setHours(0,0,0,0);

  var liste = data.filter(f => {
    var t=ddToDate(f.tarih); var b=ddToDate(snap.bas); var e=ddToDate(snap.bit);
    if(b){b.setHours(0,0,0,0);} if(e){e.setHours(23,59,59,999);} if(t){t.setHours(0,0,0,0);}
    if(b&&t&&t<b) return false;
    if(e&&t&&t>e) return false;
    if(snap.fatTur!=='Hepsi'&&f.tur!==snap.fatTur) return false;
    if(snap.fatTip!=='Hepsi'&&f.tip!==snap.fatTip) return false;
    if(snap.yanitD!=='Hepsi'&&f.yanitDurum!==snap.yanitD) return false;
    if(snap.odemeD!=='Hepsi'&&f.odemeDurum!==snap.odemeD) return false;
    if(snap.gonderen&&!f.gonderen.toLocaleLowerCase('tr-TR').includes(snap.gonderen.toLocaleLowerCase('tr-TR'))) return false;
    if(snap.no&&!f.no.toLowerCase().includes(snap.no.toLowerCase())) return false;
    if(snap.vadGec){ var v=ddToDate(f.vade); if(!v||v>=bugun) return false; }
    return true;
  });

  var toplamTutar  = liste.reduce((a,f)=>a+f.tutar,0);
  var toplamKdv    = liste.reduce((a,f)=>a+f.kdv,0);
  var bekleyenYanit= liste.filter(f=>f.yanitDurum==='BEKLEMEDE'||f.yanitDurum==='YANIT VERİLMEDİ').length;
  var gecikmis     = liste.filter(f=>f.odemeDurum==='GECİKMİŞ' || (ddToDate(f.vade) < bugun && f.odemeDurum !== 'ÖDENDİ')).length;

  var SEL="w-full bg-slate-50 border-2 border-transparent focus:border-indigo-400 rounded-xl px-4 py-3 text-xs font-black text-slate-700 outline-none uppercase tracking-widest transition-all appearance-none cursor-pointer";
  var INP="w-full bg-slate-50 border-2 border-transparent focus:border-indigo-400 rounded-xl px-4 py-3 text-xs font-black text-slate-700 outline-none uppercase tracking-widest transition-all";
  var LBL="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 pl-1";

  return (
    <div className="p-4 sm:p-8 space-y-8 animate-fade-in pb-24">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div>
          <h1 className="text-4xl font-black text-slate-800 tracking-tight">Gelen Faturalar</h1>
          <p className="text-slate-500 font-bold mt-1 uppercase text-[10px] tracking-[0.2em]">Mal & Hizmet Alım Fatura Portalı</p>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {[
          { label: 'TOPLAM FATURA (GELEN)', val: liste.length, c: 'from-slate-700 to-slate-900', i: '📥' },
          { label: 'YANIT BEKLEYEN', val: bekleyenYanit, c: 'from-amber-400 to-orange-500', i: '⏳' },
          { label: 'VADESİ GEÇMİŞ', val: gecikmis, c: 'from-rose-400 to-red-500', i: '⚠️' },
          { label: 'TOPLAM BORÇ / TUTAR', val: toplamTutar.toLocaleString('tr-TR',{minimumFractionDigits:2})+' ₺', c: 'from-indigo-500 to-purple-600', i: '💸' },
        ].map((s, i) => (
          <div key={i} className={`bg-gradient-to-br ${s.c} p-6 rounded-[2.5rem] text-white shadow-xl relative overflow-hidden group transition-all hover:scale-105`}>
            <span className="absolute top-4 right-4 text-4xl opacity-20 group-hover:scale-125 transition-transform">{s.i}</span>
            <p className="text-[10px] font-black tracking-widest uppercase opacity-70 mb-1">{s.label}</p>
            <h3 className="text-2xl sm:text-3xl font-black tracking-tighter">{s.val}</h3>
          </div>
        ))}
      </div>

      {/* Filtreler */}
      <div className="bg-white rounded-[2.5rem] shadow-xl border border-slate-100 p-6 sm:p-8">
        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-50">
          <span className="text-2xl">🔍</span>
          <h3 className="text-sm font-black text-slate-700 uppercase tracking-widest">Gelişmiş Gelen Arama</h3>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 items-end">
          <div className="col-span-2 lg:col-span-1">
            <label className={LBL}>Ay</label>
            <select value={ay} onChange={e=>ayDegis(e.target.value)} className={SEL}>
              {AYLAR.map(a=><option key={a}>{a}</option>)}
            </select>
          </div>
          <div className="col-span-2 lg:col-span-1">
            <label className={LBL}>Fatura Türü</label>
            <select value={fatTur} onChange={e=>setFatTur(e.target.value)} className={SEL}>
              {FATURA_TURLERI.map(v=><option key={v}>{v}</option>)}
            </select>
          </div>
          <div className="col-span-2 lg:col-span-1">
            <label className={LBL}>Odeme Durumu</label>
            <select value={odemeD} onChange={e=>setOdemeD(e.target.value)} className={SEL}>
              {ODEME_DURUMLARI.map(v=><option key={v}>{v}</option>)}
            </select>
          </div>
          <div className="col-span-2">
            <label className={LBL}>Gönderen / Ünvan</label>
            <input value={gonderenAra} onChange={e=>setGonderenAra(e.target.value)} className={INP} placeholder="Firma Ara..." />
          </div>
          <div className="col-span-2 lg:col-span-1">
            <button onClick={filtrele} className="w-full bg-slate-800 hover:bg-black text-white font-black text-[10px] uppercase tracking-widest py-3.5 rounded-xl shadow-lg transition-all active:scale-95">SORGULA</button>
          </div>
          <div className="col-span-2 lg:col-span-4 flex items-center justify-end">
             <label className="flex items-center gap-3 cursor-pointer select-none">
              <input type="checkbox" checked={vadGec} onChange={e=>setVadGec(e.target.checked)} className="accent-rose-500 w-5 h-5"/>
              <span className="text-xs font-black text-rose-500 uppercase tracking-widest">Sadece Vadesi Geçenler</span>
            </label>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 bg-slate-50 p-4 rounded-3xl border border-slate-100">
        <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest pl-2">
          {liste.length} Gelen Fatura Bulundu
        </p>
        <div className="flex gap-2">
          <button onClick={() => downloadExcel('gelen-faturalar', 'Gelen Faturalar', ['Fatura No','Tarih','Saat','Gönderen','TC/Vergi No','Tip','Vade','Tutar (₺)','KDV (₺)','Yanıt Durumu','Ödeme Durumu'], liste.map(f => [f.no, f.tarih, f.saat, f.gonderen, f.tcVergi, f.tip, f.vade||'—', f.tutar.toFixed(2), f.kdv.toFixed(2), f.yanitDurum, f.odemeDurum]))} className="bg-white border-2 border-slate-100 hover:border-slate-300 text-slate-600 font-black text-[9px] uppercase tracking-widest px-6 py-2 rounded-xl transition-all shadow-sm">EXCEL</button>
          <button onClick={() => printTable('Gelen Faturalar', ['Fatura No','Tarih','Saat','Gönderen','TC/Vergi No','Tip','Vade','Tutar (₺)','KDV (₺)','Yanıt Durumu','Ödeme Durumu'], liste.map(f => [f.no, f.tarih, f.saat, f.gonderen, f.tcVergi, f.tip, f.vade||'—', f.tutar.toFixed(2), f.kdv.toFixed(2), f.yanitDurum, f.odemeDurum]), `${liste.length} gelen fatura | ${bas} – ${bit}`)} className="bg-white border-2 border-slate-100 hover:border-slate-300 text-slate-600 font-black text-[9px] uppercase tracking-widest px-6 py-2 rounded-xl transition-all shadow-sm">YAZDIR</button>
        </div>
      </div>

      {/* Tablo */}
      <div className="bg-white rounded-[3rem] shadow-2xl border border-slate-100 overflow-x-auto custom-scrollbar">
        <DataTable
          anahtarAlan="id"
          satirlar={liste}
          enAzGenislik="900px"
          bosIkon="🧾"
          bosMetin="Kayıt bulunamadı"
          kolonlar={[
            {
              anahtar: 'no', baslik: 'Fatura No', siralanir: true, filtrelenir: true,
              ciz: f => (
                <>
                  <div className="font-black text-slate-700 text-xs">{f.no}</div>
                  <div className="font-mono text-[9px] text-slate-400 uppercase mt-1 opacity-50">{f.uuid}</div>
                </>
              ),
            },
            {
              anahtar: 'tarih', baslik: 'Tarih', siralanir: true, filtrelenir: true,
              ciz: f => (
                <>
                  <div className="font-black text-slate-700 text-xs">{f.tarih}</div>
                  <div className="font-black text-slate-400 text-[9px] mt-1">{f.saat}</div>
                </>
              ),
            },
            {
              anahtar: 'gonderen', baslik: 'Gönderen', siralanir: true, filtrelenir: true,
              ciz: f => (
                <>
                  <div className="font-black text-slate-800 text-xs truncate max-w-[200px]">{f.gonderen}</div>
                  <div className="font-black text-slate-400 text-[10px] mt-1">{f.tcVergi}</div>
                </>
              ),
            },
            {
              anahtar: 'tip', baslik: 'Tip', hizala: 'orta', siralanir: true,
              ciz: f => (
                <>
                  <span className="text-[9px] font-black uppercase text-slate-500 bg-slate-100 tracking-widest px-2 py-1 rounded-md">{f.tur}</span>
                  <div className="mt-2">
                    <Rozet renk={f.tip === 'e-Fatura' ? 'indigo' : 'amber'}>{f.tip}</Rozet>
                  </div>
                </>
              ),
            },
            {
              anahtar: 'vade', baslik: 'Vade', siralanir: true, filtrelenir: true,
              ciz: f => {
                const gecti = ddToDate(f.vade) < bugun && f.odemeDurum !== 'ÖDENDİ';
                return (
                  <div className="whitespace-nowrap">
                    <div className={'font-black text-xs ' + (gecti ? 'text-rose-500' : 'text-slate-700')}>{f.vade}</div>
                    {gecti && <div className="text-[9px] font-black text-rose-500 uppercase tracking-widest mt-1">⚠️ Gecikti</div>}
                  </div>
                );
              },
            },
            {
              anahtar: 'tutar', baslik: 'Tutar', hizala: 'sag', siralanir: true,
              ciz: f => (
                <>
                  <div className="font-black text-slate-800 text-sm">{f.tutar.toFixed(2)} ₺</div>
                  <div className="font-black text-slate-400 text-[9px] mt-1">KDV: {f.kdv.toFixed(2)} ₺</div>
                </>
              ),
            },
            {
              anahtar: 'odemeDurum', baslik: 'Durum', hizala: 'orta', siralanir: true, filtrelenir: true,
              ciz: f => (
                <div className="space-y-2">
                  <div>
                    <span className={'px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest ' +
                      (YANIT_BADGE[f.yanitDurum] || 'bg-slate-100 text-slate-500')}>{f.yanitDurum}</span>
                  </div>
                  <div>
                    <span className={'px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest ' +
                      (ODEME_BADGE[f.odemeDurum] || 'bg-slate-100 text-slate-500')}>{f.odemeDurum}</span>
                  </div>
                </div>
              ),
            },
            {
              anahtar: 'islem', baslik: 'İşlem', hizala: 'orta',
              ciz: f => (
                <button onClick={() => setDetay(f)}
                  className="bg-white border-2 border-slate-100 hover:border-indigo-400 hover:text-indigo-600 text-slate-400 font-black text-[9px] uppercase tracking-widest px-4 py-2 rounded-xl transition-all">
                  Detay
                </button>
              ),
            },
          ]}
        />
      </div>

      {detay && <DetayModal f={detay} onKapat={()=>setDetay(null)} onKabul={kabul} onRed={red}/>}
    </div>
  );
}